import React from "react"
import styles from "./StripeAccountCard.module.css"
import imageEmail from "assets/icons/email-icon.svg"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { CircledIcon } from "ui/CircledIcon"

export const StripeDetails = ({ stripeEmail, isStripeChargeEnabled, errorStripeMessage, stripeLink }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.stripeInfo}>
      {stripeEmail && (
        <p>
          <strong>
            <img src={imageEmail} width="16px" className="flex-shrink-0" alt="Email" /> |
          </strong>{" "}
          {stripeEmail}
        </p>
      )}

    {errorStripeMessage && (
      <div>
        <strong>{t("pro.personal_info.stripe.stripe_Error")}:</strong>
        <strong className={styles.errorMessage}>{errorStripeMessage}</strong>
      </div>
      )}
      {stripeLink && (
        <div>
          <a href={stripeLink} target="_blank" rel="noopener noreferrer">
            Attach Stripe
          </a>
        </div>
      )}


      <div className={styles.chargeStatus}>
        {isStripeChargeEnabled ? (
          <CircledIcon name="Check" colorType="success" />
        ) : (
          <CircledIcon name="AlertCircle" colorType="error" />
        )}
      </div>
    </div>
  )
}

StripeDetails.propTypes = {
  stripeEmail: PropTypes.string,
  isStripeChargeEnabled: PropTypes.bool,
  errorStripeMessage: PropTypes.string,
  stripeLink: PropTypes.string,
}
